import { TranslateService } from "@ngx-translate/core";

export class ElementData {
    public type: String = "select";
    public label: String = "Product";
    public options: any[];
    public selectedValue: String = "Select";
    public size: number = 5;
    public placeHolder: String = "Add comment";
    public hidden: boolean = false;
    
    public static getproddata(labelstr: any, show: boolean,translatedEnterLabel:String, translatedNameLabel:String): any {
        return new ElementData("selectprod", labelstr, ["", ""], "Select", 5, translatedEnterLabel + " " + labelstr + " " + translatedNameLabel, show);
    }
    public static getclonedataCategories(labelstr: any, show: boolean,translatedEnterLabel:String, translatedNameLabel:String): any {
        return new ElementData("selectCat", labelstr, ["", ""], "Select", 5, translatedEnterLabel + " " + labelstr + " " + translatedNameLabel, show);
    }
    public static getclonedatasubCategories(labelstr: any, show: boolean,translatedEnterLabel:String,translatedNameLabel:String): any {
        return new ElementData("selectsubcat", labelstr, ["", ""], "Select", 5, translatedEnterLabel + " "  + labelstr + " " + translatedNameLabel, show);
    }
    public static getattrSelectdata(labelstr: any, show: boolean,translatedEnterLabel:String,translatedNameLabel:String): any {
        return new ElementData("selectAttr", labelstr, ["", ""], "Select", 5, translatedEnterLabel + " "  + labelstr + " " + translatedNameLabel, show);
    }
    public static getselecversiondata(labelstr: any, show: boolean,translatedEnterLabel:String,translatedNameLabel:String): any {
        return new ElementData("selectversion", labelstr, ["", ""], "Select", 5, translatedNameLabel + " " + labelstr + " " + translatedEnterLabel, show);
    }
    public static getselectSortValue(labelstr: any, show: boolean): any {
        return new ElementData("sortVal", labelstr, ["", ""], "Select", 5, "Enter " + labelstr + " Name", show);
    }
    public static getselectTargetVersiondata(labelstr: any, show: boolean,translatedEnterLabel:String,translatedNameLabel:String): any {
        return new ElementData("selecttargetVersion", labelstr, ["", ""], "Select", 5, translatedEnterLabel + " " + labelstr  + " " + translatedNameLabel, show);
    }
    public static getTextandButton(labelstr: any, show: boolean): any {
        return new ElementData("textButton", labelstr, ["", ""], "", 5, "Enter " + labelstr + " Name", show);
    }
    public static getVersiondata(labelstr: any,): any {
        return new ElementData("text", labelstr, ["", ""], "", 5, labelstr , false);
    }
    public static getattrdata(labelstr: any): any {
        return new ElementData("text", labelstr, ["", ""], "", 5,labelstr, false);
    }
    public static getattrNumber(labelstr: any): any {
        return new ElementData("number", labelstr, ["", ""], "", 5, "Enter " + labelstr, false);
    }
    public static getclonedata(labelNew: any, translatedCreateLabel:String, translatedCloneLabel: String): any {
        return new ElementData("radio", translatedCreateLabel, [
            { value: labelNew, isChecked: true }, { value: translatedCloneLabel, isChecked: false }], "select", 5, "Enter Version Name", false);
    }
    public static getedidata(labelNew: any, translatedEditLable: String, translatedCloneLabel:String): any {
        return new ElementData("radio", translatedEditLable, [
            { value: labelNew, isChecked: true }, { value: translatedCloneLabel, isChecked: false }], labelNew, 5, "Enter Version Name", false);
    }
    public static getIsInternaldata(translatedKeepInternalLabel:String, translatedYes:String, translatedNo:String): any {
        return new ElementData("radio",translatedKeepInternalLabel, [
            { value: translatedYes, isChecked: false }, { value: translatedNo, isChecked: true }], "Yes", 5, "Enter Is internal", false);
    }
    public static getCurrentVersionDatacheckbox(labelstr: any, show: boolean) {
        return new ElementData("form-group", labelstr, [], "", 5, "Enter " + labelstr, show);
    }
    public static getCurrentVersionData(labelstr: any, show: boolean) {
        return new ElementData("select", labelstr, [], "", 5, "Enter " + labelstr, show);
    }
    public static getSortdata(labelstr: any, show: boolean): any {
        return new ElementData("selectSort", labelstr, ["", ""], "Select", 5, "Enter " + labelstr + " Name", show);
    }
    public static getCurrentDate(publishDateLable:String) {
        var date = new Date();
        var year = date.getUTCFullYear();
        var month = date.getUTCMonth() + 1;
        var day = date.getUTCDate();
        var dateString = year + "-" + month + "-" + day;
        if (day < 10) {
            dateString = year + "-" + month + "-" + 0 + day;
        }
        return new ElementData("date", publishDateLable, ["", ""], dateString, 5, "GA Date", false);
    }
    public static getDescData(labelstr: any) {
        return new ElementData("textarea", labelstr, ["", ""], "", 5, + " " + labelstr, false);
    }

    constructor(private typestr: String, private labelstr: String, private optionsArr: any,
        private selectedValstr: String, private sizeNo: number, private placeHolderstr: String, hidden: boolean) {
        this.type = typestr;
        this.label = labelstr;
        this.options = optionsArr;
        this.selectedValue = selectedValstr;
        this.size = sizeNo;
        this.placeHolder = placeHolderstr;
        this.hidden = hidden;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/elementdata.ts